<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'设置名称 / 续费菜单',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetPlatForm();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetPlatForm()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增设置信息'}" @finish="AddRenew()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'同步微信道具'}" @finish="SyncVirtualGoods()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-renew-setting-obj">
        <el-table :data="renewsettinglist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column type="expand" >
                <template #default="scope">
                    <el-table :data="scope.row.detail" stripe="true" empty-text="" class="TTL-table-child">
                        <template v-slot:empty><el-empty description="暂无数据" /></template>
                        <el-table-column prop="menu_name" label="付费功能" align="center" />
                        <el-table-column prop="cost" label="续费金额" align="center">
                            <template #default="tscope">
                                <div>{{tscope.row.cost}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="renewtime" label="使用时常 / 扩容空间" align="center">
                            <template #default="tscope">
                                <div>{{tscope.row.spacenums && tscope.row.spacenums!='' ? tscope.row.spacenums : tscope.row.renewtime}}</div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="note" label="备注" align="center"/> -->
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="续费名称"  align="center" />
            <el-table-column prop="product_id" label="微信道具ID"  align="center" />
            <el-table-column prop="cost" label="续费金额"  align="center" />
            <!-- <el-table-column prop="salenums" label="累计续费次数"  align="center" />
            <el-table-column prop="salecost" label="累计续费金额"  align="center" /> -->
            <el-table-column prop="managername" label="操作人"  align="center" />
            <el-table-column prop="inputtime" label="操作时间"  align="center" />
            <!-- <el-table-column prop="note" label="备注"  align="center" /> -->
            <el-table-column label="是否启用" align="center">
                <template #default="scope">
                    <div class="TTL-switch TTL-switch-center">
                        <el-switch v-model="scope.row.isstop" @change="changeisstop(scope.row.id,scope.row.isstop)"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="120">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditRenew(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DeRenew(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetPlatForm();
                    }"
                />
            </div>
        </div>
    </div>


</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_RENEW from '@/Interface/Renew/renew';
export default {
    components:{},
    data() {
        return {
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            renewsettinglist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除账号'},
                {id:2,name:'批量编辑账号'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetPlatForm();
        },

        /** 同步微信虚拟支付道具 **/
        SyncVirtualGoods() {
            this.$loading.openloading();
            INTERFACE_MODEL_RENEW.SYNC_VIRTUAL_GOODS({}).then((res) => {
                this.$loading.closeloading();
                if(res.status > 0) return false;
                var d=res.data || {};
                var fail=d.fail || [];
                if(fail.length) {
                    this.$notice({title:'消息提示',message:'成功'+(d.success||0)+'个，失败：'+fail.join('；'),type:'warning'});
                }else {
                    this.$notice({title:'消息提示',message:'已提交上传并发布到现网，约10分钟后可支付。道具ID见列表「微信道具ID」列。',type:'success'});
                }
                this.GetPlatForm();
            }).catch(() => {
                this.$loading.closeloading();
            });
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetPlatForm();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetPlatForm();
            }else {
                this.GetPlatForm();
            }
        },


        /** 数据批操作处理 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
            ids=ids.join(',');

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DeRenewMore(ids);
                }else if(index==2) {
                    this.EditRenewSettingMore(ids);
                }
               
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息 **/
        DeRenew(id) {
            this.DeRenewMore(id);
        },


        /** 删除账号信息操作 **/
        DeRenewMore(ids) {
            INTERFACE_MODEL_RENEW.DEL_RENEW_SETTING({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetPlatForm();
            });
        },


        /** 编辑账号信息 **/
        EditRenew(id) {
            this.EditRenewSettingMore(id);
        },

        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        /** 获取平台账号inxi **/
        GetPlatForm() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-renew-setting-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_RENEW.GET_RENEW_SETTING_LIST(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 var list=res.data && Array.isArray(res.data.list) ? res.data.list : [];
                 this.param.rows=res.data && res.data.count ? res.data.count : 0;
                 this.renewsettinglist=list;
                 for(var i=0;i<this.renewsettinglist.length;i++) {
                    this.renewsettinglist[i].isstop=this.renewsettinglist[i].isstop==1 ? true : false;
                 }
            }).catch(() => {
                this.$loading.closeloading(obj);
            });
        },


        /** 修改续费设置是否停用 **/
        changeisstop(id,value) {
            INTERFACE_MODEL_RENEW.RENEW_SETTING_ISSTOP({id:id,isstop:value ? 1 : 0}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetPlatForm();
            });
        },


        /** 新增续费信息 **/
        AddRenew() {
            var navinfo={name:'新增续费设置',labelentry:'AddPlatFormCostSetting',components:'AddPlatFormCostSetting',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑管理员信息 **/
        EditRenewSettingMore(ids) {
            var navinfo={name:'编辑续费设置',labelentry:'EditPlatFormCostSetting',components:'EditPlatFormCostSetting',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.renewsettinglist.length;i++) this.renewsettinglist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.renewsettinglist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.renewsettinglist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-isadmin {
    position:absolute;
    bottom:0;
    right:0;
    margin-right:-5px;
    width:25px;
    height:25px;
    border-radius: 50%;
    background-color: #ffffff;
    background-image:url(@/assets/icon/isplatform.png);
    background-repeat: no-repeat;
    background-size: 14px;
    background-position: center;
}
.money-style {color:red;font-weight: 550;}
.managerinfo {display:inline-block;width:100%;text-align: center;font-size:12px;}
.TTL-switch-center {display:inline-flex;justify-content: center;}
.TTL-names {display:inline-block;width:100%;font-weight: 550;letter-spacing: 1px;}
.TTL-names-note {display:inline-block;width:100%;font-size:12px;color:#999999;}
.TTL-table-child {display:inline-block;width:calc(100% - 100px);padding:0 0 0 100px;}
.TTL-btn-list {display:inline-flex;}
</style>